import React from "react";
import Loader from "../Loader";

const styles = {
  transition: "0.4s",
};

const SaveBtn = ({
  save = () => {},
  isSaving,
  isSaved,
  disabled = false,
  text = "Enregistrer",
  type = "primary",
  className = "",
  typeBtn = "button",
  loaderColor = "#ffffff",
  hideTextOnLoading = true,
}) => {
  return (
    <button
      type={typeBtn}
      disabled={disabled || isSaving}
      className={`d-center btn btn-${type} ${className}`}
      onClick={save}
      style={
        isSaving ? { ...styles, opacity: ".7", minHeight: 38 } : { ...styles }
      }
    >
      {isSaving && hideTextOnLoading ? null : (
        <span className={isSaving || isSaved ? "mr-2" : ""}>{text}</span>
      )}
      {isSaving && <Loader color={loaderColor} size={15} />}
      {isSaved && !isSaving && <i className="fa fa-check" />}
    </button>
  );
};

export default SaveBtn;
